import React from 'react';
import PropTypes from 'prop-types';
import {
  Block,
  BottomSheet,
  Grid,
  Heading,
  Paragraph,
  Icon,
  Button,
  Input,
  FormControl,
  XIcon,
} from '@deckee/deck-hand';
import captureSpecificError from '../../../services/sentry';

import { callEndpoint } from '../../../services/backend';

const FloatPlanInviteContact = ({ onClose, onSubmit }) => {
  const [email, setEmail] = React.useState('');
  const [isLoading, setLoading] = React.useState(false);

  const onShareSubmit = async (event) => {
    try {
      event.preventDefault();
      setLoading(true);

      // find the member if they exist
      const member = await callEndpoint(
        callEndpoint.endpoints.getMemberByEmail,
        { email },
      );

      // when a member is found attach the entire object otherwise only provided the target email
      if (member) {
        onSubmit(member);
      } else {
        onSubmit({ email });
      }

      onClose();
    } catch (err) {
      captureSpecificError(
        err,
        'containers/app-main-client/src/components/features/FloatPlan/FloatPlanInviteContact.jsx',
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <BottomSheet bg="white" type="modal-overlay">
      <BottomSheet.Heading>
        <Block position="absolute" top="16px" right="16px" onClick={onClose}>
          <Icon.Circle>
            <XIcon />
          </Icon.Circle>
        </Block>

        <Heading level={5}>Invite a new contact</Heading>
      </BottomSheet.Heading>

      <BottomSheet.Content>
        <Grid gutters={0} margins={0}>
          <Grid.Column>
            <Paragraph>
              Send your floatplan details to a new contact by email
            </Paragraph>
          </Grid.Column>

          <Grid.Column>
            <form onSubmit={onShareSubmit}>
              <FormControl label="New Contact">
                <Input
                  type="email"
                  placeholder="Email Address"
                  shape="round"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </FormControl>

              <Button type="submit" disabled={isLoading} mt="10px" wide>
                Send Invite
              </Button>
            </form>
          </Grid.Column>
        </Grid>
      </BottomSheet.Content>
    </BottomSheet>
  );
};

FloatPlanInviteContact.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default FloatPlanInviteContact;
